import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";

export default function DigitalEdition() {
  const { content } = useSite();
  const f = content.flipbook;
  useSeo("digital");
  return (
    <section className="w-full" data-testid="digital-edition-page">
      <h1 className="sr-only">{f.title}</h1>
      <iframe
        title={f.title}
        allowFullScreen
        allow="clipboard-write"
        scrolling="no"
        className="fp-iframe block w-full h-[calc(100vh-64px)] lg:h-[calc(100vh-80px)]"
        src={f.url}
        style={{ border: "1px solid lightgray" }}
        data-testid="flipbook-iframe"
      />
    </section>
  );
}
